import React from "react";
import LoginImg from "../../../../assets/images/login-img.jpg";
import FormLogin from "../../../molecules/Form/FormLogin";
import { Link } from "react-router-dom";

const Screen = () => {
  return (
    <section className="flex h-screen text-darker">
      <div className="w-7/12">
        <img src={LoginImg} alt="login-img" className="h-full object-cover" loading="lazy" />
      </div>
      <div className="w-5/12 flex flex-col justify-center items-center px-5">
        <h1 className="text-3xl font-bold mb-2">Welcome</h1>
        <p className="text-xl mb-5">Login To Continue With <span className="underline">Investor Account</span></p>
        <FormLogin>
          <div className="text-center grid items-end justify-center h-full w-full">
            <p>
              Or Login With Business Account
              <Link to="/login/business" className="text-darker font-bold ml-2 hover:underline">
                Click Here
              </Link>
            </p>
          </div>
        </FormLogin>
      </div>
    </section>
  );
};

export default Screen;
